import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialLaboratoryContractState: Dtos.LaboratoryContract & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    agreementName: null,
    noOfOriginalCTRARequired: null,
    laboratoryContractSiteTypeId: null,
    laboratoryContractSiteType: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    laboratoryConfidentialityDeed: null
}

export interface ILaboratoryContractReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    laboratory: IFieldState<Dtos.Laboratory>,
    agreementName: IFieldState<string>,
    noOfOriginalCTRARequired: IFieldState<number>,
    laboratoryContractSiteTypeId: IFieldState<number>,
    laboratoryContractSiteType: IFieldState<Dtos.LaboratoryContractSiteType>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    laboratoryConfidentialityDeed: IFieldState<Dtos.LaboratoryConfidentialityDeed>
}
